import Storage from '@/support/Storage';
import { isLocal } from '@/support/Client';
import { isObject } from 'lodash';
export class Token {
    static title() {
        return 'token';
    }
    static setLoginAsToken(bearer) {
        const ttl = isLocal() ? 5 * 60 * 1000 : 2 * 60 * 60 * 1000; // 5 min / 2 hour
        Storage.setWithExpiry('login_as_token', bearer, ttl);
    }
    static getAccessToken() {
        if (Token.getLoginAsToken()) {
            return Token.getLoginAsToken();
        }
        return Token.get('access');
    }
    static getLoginAsToken() {
        return Storage.getWithExpiry('login_as_token');
    }
    static deleteLoginAsToken() {
        Storage.delete('login_as_token');
    }
    static set(payload, value) {
        if (isObject(payload)) {
            Object.keys(payload).forEach((currentKey) => {
                Storage.set(currentKey, payload[currentKey]);
            });
        }
        else {
            Storage.set(payload, value || '');
        }
    }
    static get(key) {
        return Storage.get(key) || '';
    }
    static delete(key) {
        if (!Array.isArray(key)) {
            Storage.delete(key);
        }
        else {
            key.forEach((currentKey) => {
                Storage.delete(currentKey);
            });
        }
    }
    static deleteAll() {
        Token.deleteLoginAsToken();
        Token.delete(['access', 'refresh']);
    }
}
